// extracted by mini-css-extract-plugin
export default {"root":"styles_root__L5-LZ","link":"styles_link__zgw6Q","linkActive":"styles_linkActive__pB0ET"};